/** Default DataTable columns use ~160px. Body is icon-only; width fits the translated “Actions” header + padding. */
export const dataTableOverflowActionsColumnSizing = {
  size: 82,
  minSize: 70,
  maxSize: 104,
  enableSorting: false,
} as const;

/** Reference / ID column with copy control (e.g. finance transactions). */
export const dataTableTransactionReferenceColumnSizing = {
  size: 200,
  minSize: 168,
  maxSize: 300,
} as const;

/** Direction / type badge column. minSize accounts for cell px-4 padding + widest badge. */
export const dataTableTransactionTypeColumnSizing = {
  size: 160,
  minSize: 128,
  maxSize: 220,
} as const;

/**
 * Narrow overflow actions column — icon-only `icon-sm` trigger (e.g. finance transactions).
 * Reuse for any table where actions are only the ⋯ menu.
 */
export const dataTableTransactionsActionsColumnSizing = {
  size: 76,
  minSize: 68,
  maxSize: 92,
  enableSorting: false,
} as const;

/** Three compact icon actions displayed inline in a pinned actions column. */
export const dataTableThreeIconActionsColumnSizing = {
  size: 132,
  minSize: 116,
  maxSize: 148,
  enableSorting: false,
} as const;

/** Five compact icon actions displayed inline in a pinned actions column. */
export const dataTableFiveIconActionsColumnSizing = {
  size: 196,
  minSize: 180,
  maxSize: 212,
  enableSorting: false,
} as const;

/** Source income category — long i18n labels (e.g. FR “Catégorie source (revenus)”). */
export const dataTableTransactionSourceIncomeCategoryColumnSizing = {
  size: 232,
  minSize: 212,
  maxSize: 340,
} as const;

/** Source accounts — primary label plus optional multi-account sub-line. */
export const dataTableTransactionSourceAccountsColumnSizing = {
  size: 192,
  minSize: 172,
  maxSize: 300,
} as const;
